module.exports = __webpack_public_path__ + "static/media/ico-edit.59a57876.svg";